import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { DatatableComponent, NgxDatatableModule } from '@swimlane/ngx-datatable';

import { BillingPaymentMethodFeatureModule } from '@amfam/billing/payment-method/feature';
import { MasksModule } from '@amfam/shared/ui/masks';
import { PipesModule } from '@amfam/shared/ui/pipes';
import { ImpersonationModule } from '@amfam/shared/utility/impersonation';
import { SharedServicesModule } from '@amfam/shared/utility/shared-services';
import { UiKitModule } from '@amfam/ui-kit';

import { PaymentMethodsComponent } from './containers/payment-methods.component';

@NgModule({
  imports: [
    CommonModule,
    UiKitModule,
    SharedServicesModule,
    RouterModule,
    PipesModule,
    FormsModule,
    ReactiveFormsModule,
    NgxDatatableModule,
    ImpersonationModule,
    MasksModule,
    BillingPaymentMethodFeatureModule
  ],
  declarations: [PaymentMethodsComponent],
  exports: [PaymentMethodsComponent],
  providers: [DatatableComponent]
})
export class BillingPaymentaccountFeatureModule {}
